type Params = {
  brandId: string;
  pageId: string;
  prompt: string;
  order?: number;
};

export type GenerateAIPageModuleResponse = {
  moduleName: string;
  games: { name: string; externalId: string }[];
  error?: string;
  moduleId?: string;
};

export const generateAIPageModule = async ({
  brandId,
  pageId,
  prompt,
  order,
}: Params): Promise<GenerateAIPageModuleResponse> => {
  if (!process.env.REACT_APP_GENERATE_AI_MODULE_URL) {
    throw new Error("REACT_APP_GENERATE_AI_MODULE_URL is not defined");
  }

  const request = await fetch(process.env.REACT_APP_GENERATE_AI_MODULE_URL, {
    method: "POST",
    body: JSON.stringify({ brandId, pageId, prompt, order }),
    headers: {
      "Content-Type": "application/json",
      "x-environment": `${process.env.REACT_APP_ENVIRONMENT}`,
    },
  });

  if (!request.ok) {
    throw new Error("Failed to generate AI page module");
  }

  const data = await request.json();

  return data;
};
